"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFileMime = void 0;
var mimesDictionary = {
    pdf: "application/pdf",
    jpeg: "image/jpeg",
    png: "image/png",
    gif: "image/gif",
    svg: "image/svg+xml",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    odt: "application/vnd.oasis.opendocument.text",
    xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ods: "application/vnd.oasis.opendocument.spreadsheet",
    csv: "text/csv",
};
var isFileMime = function (file, extensions) {
    if (window.FileReader && window.Blob) {
        if (!file) {
            throw new Error("Wizard: a file must be provided");
        }
        if (Array.isArray(file)) {
            throw new Error('Pass a single file to isFileSmallerThan');
        }
        var fileType = file.type;
        var mimes = extensions.map(function (extension) { return mimesDictionary[extension]; }) || [];
        return mimes.includes(fileType);
    }
    else {
        throw new Error("Files and Blob are not supported");
    }
};
exports.isFileMime = isFileMime;
//# sourceMappingURL=isFileMime.js.map